<template>
  <v-dialog
    v-model="shareDialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        color="#606770"
        text
        class="info-contents-btn"
        @click="displayEmbedPanel = false"
      >
        <v-icon class="mr-1" size="21">$vuetify.icons.mdiShareVariant</v-icon>
        <span class="hidden-xs-only">{{ $t('actions.share') }}</span>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class=" blue-purple-gradient">
        <span v-if="!displayEmbedPanel">{{ $t('actions.share') }}</span>
        <span v-else>{{ $t('actions.embed_story') }}</span>
        <v-spacer />
        <v-btn class="ma-0" icon @click="shareDialog = false">
          <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text v-show="!displayEmbedPanel">
        <v-layout class="mt-10 mb-3">
          <span v-if="isStory" class="d-flex layout column align-center">
            <v-btn icon large class="color-grey" @click="toggleEmbedPanel">
              <v-icon>{{icons.mdiCodeTags}}</v-icon>
            </v-btn>
            <span>{{ $t('actions.embed') }}</span>
          </span>

          <v-flex v-for="social in socials" :key="social.network">
          <share-network
            :network="social.network"
            :url="url"
            :title="title"
            :description="description"
            :quote="quote"
            :media="media"
            twitter-user="elementari"
          >
            <v-btn icon large :class="'color-' + social.network">
              <v-icon>{{getIcon(social.icon)}}</v-icon>
            </v-btn>
            <div>{{social.name}}</div>
          </share-network>
          </v-flex>

        </v-layout>
        <v-flex>
          <v-text-field id="urlTextField" :value="url" filled readonly>
            <v-btn
              slot="append"
              text
              color="primary"
              class="mt-0"
              @click="copyUrl"
            >
              {{ $t('actions.copy') }}
            </v-btn>
          </v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-text v-show="displayEmbedPanel">
        <div style="border-bottom: 1px solid #ddd">
          <textarea
            :value="getEmbedCode"
            class="embedModal-textarea"
            rows="1"
            autocomplete="off"
            placeholder=""
          />
        </div>
        <div style="padding: 15px 0px">
          {{ $t('reader.messages.embed.agreement1') }}
          <nuxt-link :to="localePath('/policy/terms/')">
            {{ $t('reader.messages.embed.agreement2') }}
          </nuxt-link>
          .
        </div>
      </v-card-text>
      <v-divider />
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiCodeTags
}from '@mdi/js'
export default {
  props: {
    url: {
      type: [String],
      required: true,
      default: ''
    },
    title: {
      type: [String],
      required: true,
      default: ''
    },
    description: {
      type: [String],
      required: true,
      default: ''
    },
    quote: {
      type: [String],
      required: true,
      default: ''
    },
    media: {
      type: [String],
      required: true,
      default: ''
    },
    isStory: {
      type: [Boolean],
      required: false,
      default: false
    }
  },

  data: () => ({
    icons: {
      mdiCodeTags
    },
    shareDialog: false,
    displayEmbedPanel: false,
    socials: [
      { network: 'facebook', icon: 'mdiFacebook', name: 'Facebook' }, 
      { network: 'twitter', icon: 'mdiTwitter', name: 'Twitter' }, 
      { network: 'pinterest', icon: 'mdiPinterest', name: 'Pinterest' }, 
      { network: 'reddit', icon: 'mdiReddit', name: 'Reddit' },
      { network: 'linkedin', icon: 'mdiLinkedin', name: 'Linkedin' }, 
      { network: 'whatsapp', icon: 'mdiWhatsapp', name: 'Whatsapp' }, 
    ]
  }),
  computed: {
    getEmbedCode: function() {
      return (
        '<iframe width="560" height="347" src="' +
        this.url +
        'embed" frameborder="0";  allow="encrypted-media; microphone" allowfullscreen></iframe>'
      )
    }
  },
  methods: {
    getIcon(iconName) {
      return this.$vuetify.icons.values[iconName]
    },
    toggleEmbedPanel: function() {
      this.displayEmbedPanel = !this.displayEmbedPanel
    },
    copyUrl: function() {
      var dummy = document.getElementById('urlTextField')
      dummy.select()
      document.execCommand('copy')
    }
  }
}
</script>

<style>
.color-grey {
  background: #f4f4f4;
  color: #999999 !important;
}
.color-grey2 {
  background: #888888;
  color: white !important;
}
.color-link {
  background: #888888;
  color: white !important;
}
.color-twitter {
  background: #1da1f2;
  color: white !important;
}
.color-facebook {
  background: #3b5998;
  color: white !important;
}
.color-youtube {
  background: #cd201f;
  color: white !important;
}
.color-pinterest {
  background: #bd081c;
  color: white !important;
}
.color-reddit {
  background: #ff4500;
  color: white !important;
}
.color-linkedin {
  background: #0077b5;
  color: white !important;
}
.color-whatsapp {
  background: #25d366;
  color: white !important;
}
.color-weibo {
  background: #e6162d;
  color: white !important;
}
.color-instagram {
  background: #e4405f;
  color: white !important;
}
.color-pinterest {
  background: #bd081c;
  color: white !important;
}
.color-tumblr {
  background: #34465d;
  color: white !important;
}
.color-blogger {
  background: #f57d00;
  color: white !important;
}
.color-behance {
  background: #131418;
  color: white !important;
}
.color-dribbble {
  background: #ea4c89;
  color: white !important;
}
.color-soundcloud {
  background: #ff3300;
  color: white !important;
}
.color-deviantart {
  background: #05c645;
  color: white !important;
}
.color-patreon {
  background: #f06451;
  color: white !important;
}
.color-kofi {
  background: #fe6060;
  color: white !important;
}
.color-etsy {
  background: #e9611d;
  color: white !important;
}

.embedModal-textarea {
  resize: none;
  position: relative;
  outline: 0;
  box-shadow: none;
  padding: 0;
  width: 100%;
  background: 0 0;
  border: none;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-family: Roboto, monospace;
  line-height: 24px;
  min-height: 90px;
}
</style>
